import { createSlice } from '@reduxjs/toolkit'
import { LoadingStates } from '../../utils/enums'
import { getTeamsShared } from './actions'


const initialState = {
  items: [],
  isLoading: LoadingStates.IDLE,
  error: null,
  teamId: '',
  channelId: '',
  itemId: '',
  path: '',
  name: '',
  history: [],
  authorizeTeams: false,
}

const teamsChannelSlice = createSlice({
  name: 'teamsChannel',
  initialState,
  reducers: {
    setPath: (state, action) => {
      if (action.payload.teamId) state.teamId = action.payload.teamId
      if (action.payload.channelId) state.channelId = action.payload.channelId
      if (action.payload.itemId) state.itemId = action.payload.itemId
      if (action.payload.path) state.path = action.payload.path
      if (action.payload.name) state.name = action.payload.name
    },
    addToHistory: (state, action) => {
      state.history.push(action.payload)
    },
    goBack: (state, action) => {
      const index = action.payload.index
      const preHistory = state.history.slice(0, index + 1)
      if (preHistory) {
        state.channelId = action.payload.channelId
        state.teamId = action.payload.teamId
        state.itemId = action.payload.itemId
        state.name = action.payload.name
        state.path = action.payload.path
        state.history = [...preHistory]
      }
    },
    resetDrive: (state) => {
      state.items = initialState.items
      state.isLoading = initialState.isLoading
      state.error = initialState.error
      state.channelId = initialState.channelId
      state.teamId = initialState.teamId
      state.itemId = initialState.itemId
      state.path = initialState.path
      state.name = initialState.name
      state.itemId = initialState.itemId
      state.history = initialState.history
    },
    setTeamsAuthorize: (state, action) => {
      state.authorizeTeams = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTeamsShared.pending, (state, action) => {
        state.isLoading = LoadingStates.PENDING
      })
      .addCase(getTeamsShared.fulfilled, (state, action) => {
        state.isLoading = LoadingStates.FULFILLED
        state.items = action.payload?.data || []
      })
      .addCase(getTeamsShared.rejected, (state, action) => {
        state.isLoading = LoadingStates.REJECTED
        state.error = action.error
      })
  },
})

export default teamsChannelSlice.reducer
export const { setPath, addToHistory, goBack, resetDrive, setTeamsAuthorize } =
  teamsChannelSlice.actions


